 
import React from "react";
import Logo from "./Logo";
import Language from "./Language";
import Profile from "./Profile";

import "./../../../styles/HeaderComponent.scss";

// Header component 
// Defines header elements for the app
export default  function HeaderComponent(props) {
    return ( 
        props.loginPage ? 
        <header className='header-login'>
            <div className="header-container">
                <Logo />
            </div>
        </header> 
        : 
        <header className='header'>
            <div className="header-container">
                <Logo login={false}/>
                <div className="flex">
                    <Language />
                    {
                        window.location.pathname.includes('/TerminosYCondiciones') ? <></> : <Profile />
                    }

                </div>
            </div>
        </header>
     );
}
